import React from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import MoneyIcon from '@material-ui/icons/Money';

export default function CategoriesPlaceholder() {
  return (
    <Box
      alignSelf='center'
      display='flex'
      flexDirection='column'
      alignItems='center'
    >
      <MoneyIcon fontSize='large' />
      <Typography align='center' variant='h6'>
        Nenhum registro selecionado
      </Typography>
      <Typography align='center' variant='body2'>
        Selecione no menu à esquerda.
      </Typography>
    </Box>
  );
}
